import { AiFillApp } from 'api/ai-fill/types';

// TODO @kadhirr im changing aiFillAppId for the default also here, since they dont need the strings for BE. Test and change as appropriate
export const getAIFillAppId = (app: AiFillApp): string | number =>
  app.aiFillAppId;
export const getAIFillAppName = (app: AiFillApp): string =>
  app.aiFillAppConfig.title ?? app.aiFillAppConfig.goal;
